module.exports = __webpack_public_path__ + "img/buttonbom.81eea1d2.png";